import React from 'react'
import projectloop from './projectloop'
import { useState } from 'react'
import { Link} from 'react-router-dom'

const Project = () => {
  const [readMore, setReadMore] = useState(false)
  const toggleState = () =>{
    setReadMore(prevState => !prevState)
  }
  
   
    // let setLoop = [];
    // for(let i =0; i<=3; i++){
    //  setLoop.push(cryptoLoop);
    // }
  
  return (
    <>
    <h1 className="overflow-hidden p-10 text-3xl md:text-5xl  font-extrabold text-center mb-12 tracking-widest
         overline  decoration-solid decoration-slate-200 mt-3 " >
            PROJECTS
           </h1>
    <section className="bg-bgFooter">
    
        <div className="container overflow-hidden -mt-14 md:mt-0 py-12 mx-auto px-2 xl:px-14 ">
       
     
    
        
           <div className="project  grid grid-cols-1 md:grid-cols-2 gap-y-20 md:gap-y-36 md:gap-x-32  ">
           {
            projectloop.map(({url, title, description, description2, visit, link }, index)=>(
              <div className=" first md:max-w-2xl
              border border-indigo-600
              bg-bgFooter shadow-lg shadow-blue-500/100 lg:p-6 xl:p-5 sm:p-10 p-14 rounded-3xl 
              transform hover:translate-y-8 h-max">
             <img src={url} alt="" className="w-full h-max"/>
              <h1 className='text-center font-bold text-3xl py-12 lg:py-10 xl:py-14'>{title}</h1>
              <p className='mb-8 text-2xl text-ellipsis px-1 md:px-6'>
                {description}
                {
                readMore && <p>{description2}</p> }
              
             <small> <button onClick={toggleState} className="bg-zinc-100 p-1 m-1" >{readMore ? 'Read less': 'Read more..'}</button></small></p>
                <div class="border-solid border-2 text-xl md:text-2xl w-36 md:w-52 
                text-center mx-auto p-4  border-indigo-600 ...">
              <a href={link} target="_blank" rel="noreferrer">{visit}</a>

                </div>
          </div>
            ))
           }
          </div>

        </div>
        <div class="text-center py-14 text-2xl"><p className='mb-6'>To explore more of these projects 
 please vist my Github </p>
        <span className='mt-6'>
            <a href='https://github.com/santosh10000' target="_blank" rel="noreferrer"
            className='border-solid border-2 text-2xl w-52 text-white 
            text-center mx-auto p-3 rounded-lg bg-indigo-600 ...'
            > Visit Github</a>
            </span></div>
    </section>
    </>
  )
}

export default Project